var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#ecc711;}.a{stroke:#707070;opacity:0;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(333 306)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(334.146 265.271)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 51.613)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.528,231.311H16.4a3.17,3.17,0,0,0-.836.112,3.183,3.183,0,0,0-2.836-1.743H8.976a3.183,3.183,0,0,0-2.836,1.743,3.17,3.17,0,0,0-.836-.112H3.18A3.184,3.184,0,0,0,0,234.491v3.4A1.91,1.91,0,0,0,1.908,239.8H19.8a1.91,1.91,0,0,0,1.908-1.908v-3.4A3.184,3.184,0,0,0,18.528,231.311ZM5.8,232.86v5.664H1.908a.637.637,0,0,1-.636-.636v-3.4a1.91,1.91,0,0,1,1.908-1.908H5.3a1.9,1.9,0,0,1,.5.067C5.8,232.719,5.8,232.789,5.8,232.86Zm8.844,5.664H7.068V232.86a1.91,1.91,0,0,1,1.908-1.908h3.756a1.91,1.91,0,0,1,1.908,1.908Zm5.8-.636a.637.637,0,0,1-.636.636H15.912V232.86c0-.071,0-.141-.008-.21a1.9,1.9,0,0,1,.5-.067h2.125a1.91,1.91,0,0,1,1.908,1.908Z",
    transform: "translate(0 -229.68)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.417 47.239)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.24,126.5a2.826,2.826,0,1,0,2.826,2.826A2.829,2.829,0,0,0,36.24,126.5Zm0,4.379a1.554,1.554,0,1,1,1.554-1.554A1.555,1.555,0,0,1,36.24,130.883Z",
    transform: "translate(-33.414 -126.504)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.079 43.729)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M170.737,43.729a3.775,3.775,0,1,0,3.775,3.775A3.779,3.779,0,0,0,170.737,43.729Zm0,6.278a2.5,2.5,0,1,1,2.5-2.5A2.506,2.506,0,0,1,170.737,50.007Z",
    transform: "translate(-166.962 -43.729)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.64 47.239)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M348.12,126.5a2.826,2.826,0,1,0,2.826,2.826A2.829,2.829,0,0,0,348.12,126.5Zm0,4.379a1.554,1.554,0,1,1,1.554-1.554A1.555,1.555,0,0,1,348.12,130.883Z",
    transform: "translate(-345.294 -126.504)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.7ddc84191a6d8ddd061bbb62665917fb.svg";
export { ForwardRef as ReactComponent };